import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import Button from "@/components/button";
import { CommonAction } from "@/actions/common/common";
import { InfoModalStyle } from "@/imports-files/components/common-modal/common-modal";
import Modal from "../common-modal/modal";
export function InformationModal(props) {
  const commonAction = new CommonAction();
  return (
    <Modal
      type="info"
      className={`RequestMore mt20`}
      heading={props?.infoModal.heading}
      closeModal={() =>
        props.setInfoModal({ state: false, heading: "", message: "" })
      }

      innerContent={
          <div className={`${PageStyle.Contentdata1}`}>
            {props?.infoModal?.job_status == "Rejected" ? (
              <ul>
                {props?.infoModal?.message?.map((message, index) => {
                  return (
                    <li
                      className={`${PageStyle.ListItem} mt20`}
                      key={`rejected_message_${index}`}
                    >
                      {message}
                    </li>
                  );
                })}
              </ul>
            ) : (
              <table className="ApproverList">
                <tr>
                  <th>Approver</th>
                  <th>Status</th>
                </tr>
                {props?.infoModal?.message.map((element, index) => {
                  return (
                    <tr>
                      <td>
                        <div
                          key={`job_owner_initials_${index}`}
                          className="d-flex align-items-center w100"
                        >
                          {element?.photo_url ? (
                            <div className="JobInitialname mr5">
                              <img
                                src={element?.photo_url}
                                className="JobImage"
                              />
                            </div>
                          ) : (
                            <div className="JobInitialname mr5">
                              <div>
                                {element.name_initials
                                  ? element.name_initials
                                  : "?"}
                              </div>
                            </div>
                          )}
                          <span className="ApproverEmail">
                            {element.name || element.email}
                          </span>
                        </div>
                      </td>
                      <td>
                        <span className="ApproverStatus">
                          {element.status}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </table>
            )}
          </div>
      }
    />
  );
}
